/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-06-23 10:24:17
 */

import type {ListItem} from '~/types/field.types';

/**
 * Convert an array into a dropdown items list
 * @param list - Array of string
 * @returns - Array of List items
 */
export const arrayToDropdownList = (list: Array<string>): ListItem[] => {
  return list.map(val => ({
    label: val,
    value: val,
  }));
};
